import React from 'react';
import { Link, useLocation } from "react-router-dom";
import Style from '../user/__user-list.module.css';

/*
    - ihoDesignSystem
*/
import { Grid, Box, List, Typography } from '@iho-design-system/Loader';

const Tab = () => {

    /*
        - tabLocation
    */
    const location = useLocation();
    let subOrganizationActive, memberActive, passengerActive, agentActive;
    if (location.pathname === '/user/sub-organization') {
        subOrganizationActive = 'active';
        memberActive = '';
        passengerActive = '';
        agentActive = '';
    }
    if (location.pathname === '/user/member') {
        subOrganizationActive = '';
        memberActive = 'active';
        passengerActive = '';
        agentActive = '';
    }
    if (location.pathname === '/user/agent') {
        subOrganizationActive = '';
        memberActive = '';
        passengerActive = '';
        agentActive = 'active';
    }
    if (location.pathname === '/user/passenger') {
        subOrganizationActive = '';
        memberActive = '';
        passengerActive = 'active';
        agentActive = '';
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <List
                            className={`d-flex justify-content-center pointer`}>
                            <List.Item>
                                <Link
                                    to='/user/sub-organization'>
                                    <Typography
                                        className={`${Style[subOrganizationActive]} py-sm px-sm text-center rounded-sm`}>
                                        سازمان‌های زیرمجموعه
                                    </Typography>
                                </Link>
                            </List.Item>
                            <Box
                                className={`mx-sm`} />
                            <List.Item>
                                <Link
                                    to='/user/member'>
                                    <Typography
                                        className={`${Style[memberActive]} py-sm px-sm text-center rounded-sm`}>
                                        مدیریت اعضا
                                    </Typography>
                                </Link>
                            </List.Item>
                            <Box
                                className={`mx-sm`} />
                            <List.Item>
                                <Link
                                    to='/user/agent'>
                                    <Typography
                                        className={`${Style[agentActive]} py-sm px-sm text-center rounded-sm`}>
                                        مدیریت نمایندگان
                                    </Typography>
                                </Link>
                            </List.Item>
                            <Box
                                className={`mx-sm`} />
                            <List.Item>
                                <Link
                                    to='/user/passenger'>
                                    <Typography
                                        className={`${Style[passengerActive]} py-sm px-sm text-center rounded-sm`}>
                                        لیست مهمانان
                                    </Typography>
                                </Link>
                            </List.Item>
                        </List>
                        <Box
                            className={`my-sm mb-0 divider-horizontal divider-light`} />
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );

}

export default Tab;